import React, { Component } from 'react';
import PassengersListWrapper from '../../passengersList/PassengersListWrapper';
import RouteTabs from '../../routeTabs/RouteTabs';
import SeatsDesktopProps from './SeatsDesktopProps';
import ClassNames from 'classnames';
import Dictionary from '../../../model/Dictionary';
import SeatSelectionDesktopContainer from './SeatSelectionDesktopContainer';
import SeatRowAction from '../../passengersList/SeatRowAction';
import './SeatsDesktop.css';
import Constants from '../../../model/AppConfiguration';

export default class SeatsDesktopScreen extends Component {
  static propTypes = SeatsDesktopProps;

  submitData = step => {
    this.props.submitFlights(Constants.REQUEST.SEATS, this.props.general, this.props.flights, step);
  };

  render () {
    const {
      routeId,
      routes,
      flights,
      selectedRoute,
      selectedTrip,
      toggleRoutes,
      editOpened,
      selectedPassenger,
      openEditPassenger,
      closeEditPassenger,
    } = this.props;

    let mainContainerClass = ClassNames({
      'col-12': !editOpened,
      'col-8': editOpened,
      'full-height': true,
    });
    let editPassengerClass = ClassNames({ 'col-4': editOpened });

    return (
      <div className='row seats'>
        <div className={mainContainerClass}>
          <h1>{Dictionary.seats.title}</h1>
          <RouteTabs
            isMain
            showDate
            routes={routes}
            selectedTrip={selectedTrip}
            selectedRoute={selectedRoute}
            toggleRoutes={toggleRoutes}
            TabContent={
              <PassengersListWrapper
                showOnlySelected
                flights={flights}
                routeId={routeId}
                onItemClickAction={openEditPassenger}
                selectedPassenger={selectedPassenger}
                RowAction={SeatRowAction}
              />
            }
          />
        </div>
        {!editOpened ? null : (
          <div style={{ padding: 0 }} className={editPassengerClass}>
            <SeatSelectionDesktopContainer
              showDate
              centered
              routes={routes}
              selectedTrip={selectedTrip}
              selectedRoute={selectedRoute}
              toggleRoutes={toggleRoutes}
              handleClose={closeEditPassenger}
              selectedPassenger={selectedPassenger}
            />
          </div>
        )}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/containers/seats/desktop/SeatsDesktopScreen.js